import "../../styles/components/BButton.css";
const SpaceBar = (props) => <>&nbsp;&nbsp;&nbsp;&nbsp;</>
  
export default SpaceBar;
